/**
 * @file 简体中文话术
 * @author zhujialu
 */
define(function (require) {
    'use strict'

    var language = require('./chineseSimplifiedLive')

    language.BUTTON_START_CLASS = '开播'

    language.BUTTON_START_CLASS_FOR_SELL = '开播'

    language.BUTTON_END_CLASS = '下播'

    language.BUTTON_END_CLASS_FOR_SELL = '下播'

    language.INFO_CLASS_START = '开播啦'

    language.INFO_CLASS_END = '下播啦'

    language.BUTTON_END_CLASS_AND_REMOVE_ALL = '下播并移出学生'

    language.CONFIRM_END_CLASS = '确认要下播吗？'

    language.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_TEACHER = '请先点击开播按钮'

    language.BUTTON_SELL_PRODUCT = '商品'

    language.BUTTON_SELL_VIDEO_LAYOUT = '纯视频模板'

    language.BUTTON_SELL_PPT_LAYOUT = 'PPT带货模板'

    /**
     * =================================================
     * 字幕
     * =================================================
     */
    language.BUTTON_CAPTION = '字幕'

    language.BUTTON_CLOSE_CAPTION = '关闭字幕'

    language.BUTTON_LUCKY_BAG = '优惠券'

    language.TIP_END_LUCKY_BAG = '优惠券停止将无法恢复，请谨慎操作'

    language.BUTTON_SHOP = '购物车'

    language.BUTTON_REPORT = '举报'

    language.DIALOG_REPORT_TITLE = '请选择举报原因'

    /**
     * =================================================
     *  cpu 提示
     * =================================================
     */
    language.TIP_CPU_HIGH_LIMIT_SCREEN_SHARE = '系统检测当前CPU超过70%，使用“屏幕共享”会导致直播异常，不支持开启！'

    language.TIP_CPU_HIGH_LIMIT_BEAUTY = '系统检测当前CPU超过70%，开启“美颜/虚拟背景”会导致直播异常，不支持开启！'

    language.TIP_CPU_HIGH_END_SCREEN_SHARE = '系统检测当前CPU超过80%，使用“屏幕共享”会导致直播异常，已为您中断共享！'

    language.TIP_CPU_HIGH_END_BEAUTY = '系统检测当前CPU超过80%，继续使用“美颜/虚拟背景”会导致直播异常，已为您关闭！'

    return language
})
